// hooks/useNotificationSnack.js

import { MdOutlineInbox } from "react-icons/md";
import { toast } from "react-toastify";

import { getLanguage } from "../utils/getLanguage";
import { useNavigateWithLang } from "../utils/navigation";
import useAuth from "./useAuth";

export const useNotificationSnack = () => {
  const lang = getLanguage();
  const user = useAuth();
  const role = user?.role?.toLowerCase() || "student";
  const navigate = useNavigateWithLang();

  const showNotificationSnack = (notification) => {
    const message = notification.message;
    const messageText = lang === "ar" ? message?.ar : message?.en || "New notification";

    const toastOptions = {
      containerId: "notification",
      style: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "12px 16px",
        fontSize: "15px",
        fontWeight: 500,
        backgroundColor: "#ffffff",
        color: "#1c1e21",
        borderRadius: "10px",
        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
        border: "1px solid #e4e6eb",
        maxWidth: "400px",
      },
      icon: false,
    };

    toast(
      <div
        className="flex cursor-pointer items-center gap-2"
        onClick={() => navigate(`/${role}/notifications-center`)}
      >
        <span style={{ fontSize: "24px" }}>
          <MdOutlineInbox />
        </span>
        <span>{messageText}</span>
      </div>,
      toastOptions
    );
  };

  return { showNotificationSnack };
};
